import { useParams } from 'react-router-dom'

import EditMedicalLeave from 'modules/timeoff/components/EditMedicalLeave'

import { useOnClose } from './useOnClose'

const EditMedicalLeavePage = () => {
  const { leave_id: leaveId, id } = useParams()
  const onClose = useOnClose(id)

  if (leaveId === undefined) {
    return null
  }

  return <EditMedicalLeave leaveId={+leaveId} onClose={onClose} />
}

export default EditMedicalLeavePage
